import { connect } from 'react-redux';
import UpdatedDate from '../components/UpdatedDate';

export default connect(
  ({data}) => ({date: data.updated_at})
)(UpdatedDate);
